import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login.service';

@Injectable({
  providedIn: 'root',
})
export class IsloggedAuthGuard {
  constructor(
    public auth: LoginService,
    public router: Router
  ) {}
  canActivate() {
    if (this.auth.isAuthenticated()) {
      this.router.navigate(['inicio']);
      return false;
    }
    return true;
  }
}
